import { type MantineColor } from '@mantine/core'
import { type ReactNode, useMemo } from 'react'

import { useTranslation } from '@flecto/translations'
import { type CoreBooking, type CoreBookingStatus } from '@flecto/types'

export type UseBookingStatusProps = {
  booking?: CoreBooking
}

export type BookingStatusDefinition = {
  color: MantineColor
  label: ReactNode
  status: CoreBookingStatus
}

export function useBookingStatus({ booking }: UseBookingStatusProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'bookings' })

  const allStatuses: Record<CoreBookingStatus, BookingStatusDefinition> = {
    drafting: {
      color: 'gray',
      status: 'drafting',
      label: t('booking_status.drafting'),
    },
    negotiating: {
      color: 'purple',
      status: 'negotiating',
      label: t('booking_status.negotiating'),
    },
    negotiation: {
      color: 'purple',
      status: 'negotiating',
      label: t('booking_status.negotiating'),
    },
    reserved: {
      color: 'blue',
      status: 'reserved',
      label: t('booking_status.reserved'),
    },
    ongoing: {
      color: 'orange',
      status: 'ongoing',
      label: t('booking_status.ongoing'),
    },
    completed: {
      color: 'green',
      status: 'completed',
      label: t('booking_status.completed'),
    },
    canceled: {
      color: 'red',
      status: 'canceled',
      label: t('booking_status.canceled'),
    },
  }

  const bookingStatus = useMemo(
    () => allStatuses[(booking?.status ?? 'drafting') as CoreBookingStatus],
    [booking]
  )

  return { allStatuses, bookingStatus }
}
